export default __webpack_public_path__ + "6a3333dd7514290ba8daf39567a10cc4.svg";